import { defineComponent as _defineComponent } from 'vue'

  import Modal from "../Modal.vue";
  import plural from "@/features/plural";
  import router from "@/router";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'SuccessBuilderQuoteModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    lot: {
      type: Object,
      required: true,
    },
    estateId: {
      type: String,
      required: true,
    },
  },
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emits = __emit;
  const onClose = () => {
    router.push({ name: "EstateMap", params: { estateId: props.estateId } });
    emits("close");
  };

const __returned__ = { props, emits, onClose, Modal, get plural() { return plural }, get router() { return router } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})